import { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { Card } from '../../../components/card/card';
import { Page } from '../../../components/page/page';
import { Tabs, TabType } from '../../../components/tabs/tabs';
import { NotificationsPath } from '../../../routes/manager/manager-enums';
import { useNotifications } from '../use-notifications';

export type MobileNotificationsContextType = ReturnType<typeof useNotifications>;

export const MobileNotifications = () => {
  const navigate = useNavigate();
  const { handleRemoveNotification, notifications, t, isLoading } = useNotifications();

  const tabs: TabType[] = [
    {
      id: NotificationsPath.All,
      label: t('Все'),
    },
    {
      id: NotificationsPath.Reviews,
      label: t('Отзывы'),
    },
    {
      id: NotificationsPath.Staff,
      label: t('Сотрудники'),
    },
  ];

  const [activeTab, setActiveTab] = useState<TabType>(tabs[0]);

  return (
    <Page>
      <h2>{t('Уведомления')}</h2>

      <Card>
        <Tabs
          fullWidth
          tabs={tabs}
          activeTab={activeTab}
          onChange={(e) => {
            setActiveTab(e);
            navigate(e.id);
          }}
        />

        <Outlet context={{ handleRemoveNotification, notifications, isLoading }} />
      </Card>
    </Page>
  );
};
